"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2497],{

/***/ 15288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useRouterQuery; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



/**
 * Like `useRouter().query` but will return it on first render
 */

function useRouterQuery() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var asPath = router.asPath,
      query = router.query,
      pathname = router.pathname;
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    // if we have query params from the router, let's return that
    if (Object.keys(query).length > 0) {
      return query;
    } // split path by `/` or `?`


    var pathnameParts = pathname.split(/\/|\?/);
    var loc = typeof window !== 'undefined' ? {
      query: Object.fromEntries(new URLSearchParams(window.location.search)),
      pathname: location.pathname
    } : {
      query: query,
      pathname: asPath
    };
    var asPathParts = loc.pathname.split(/\/|\?/); // actual query object that we wanna use

    var actualQuery = {};

    for (var index = 0; index < pathnameParts.length; index++) {
      var part = pathnameParts[index];

      if (!part.startsWith('[') || !part.endsWith(']')) {
        continue;
      } // extract real query param from `post/[id]` style routes
      // removes first and last character


      var key = part.slice(1, -1);

      if (key.startsWith('...')) {
        // catch-all route
        var catchAllKey = key.slice(3);
        actualQuery[catchAllKey] = asPathParts.splice(index);
        break;
      } // append to "actual query"


      actualQuery[key] = asPathParts[index];
    }

    for (var _key in loc.query) {
      actualQuery[_key] = loc.query[_key];
    }

    return actualQuery;
  }, [asPath, query, pathname]);
}


//# sourceMappingURL=next-router-query.esm.js.map


/***/ }),

/***/ 33796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ AuctionFiles; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33052);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36573);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75920);





function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-1 flex-col mb-10"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "font-medium text-xl mb-3"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "flex flex-wrap gap-2"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject());
var Title = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().p(_templateObject1());
var Line = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject2());
var AuctionFiles = function(param) {
    var files = param.files;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)('auctions').t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                children: t('auctionFiles')
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Line, {
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .removeDuplicateObjects */ .md)(files).map(function(f, i) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: f.url,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                            title: f.filename,
                            value: "download-auction-file"
                        })
                    }, "fk-".concat(i));
                })
            })
        ]
    }));
};


/***/ }),

/***/ 68921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ ContactCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../core/src/components/ResponsiveImage.tsx
var ResponsiveImage = __webpack_require__(17094);
;// CONCATENATED MODULE: ../assets/icons/phone-green.png
/* harmony default export */ var phone_green = ({"src":"/_next/static/media/phone-green.363d617b.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEVMaXEaoYYaoYYaoYYaoYYaoYYaoYYaoYbuAd4sAAAACHRSTlMAhnZBCBZgMQ31jvwAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAuSURBVAiZPcrHDQAwDAJAisv+G1uyo/A6AcBP0wdZsXDpmiBLuybZzFXp3ZCBAQuaAGOQWTQDAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/icons/mail-green.png
/* harmony default export */ var mail_green = ({"src":"/_next/static/media/mail-green.face877b.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEVMaXEaooYaooYaoYYaoYcboYYaooYaoYYaoYYVLNWaAAAACXRSTlMAUj6NeyAcqWw+2Lg0AAAACXBIWXMAACE4AAAhOAFFljFgAAAAL0lEQVQImUXLsREAIBCEQLhX3/4rdkyUaBPgtaJZQFdSDYyte1yQcFEmFjBV558PEGsAa8/hBXYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ../core/src/components/ContactCard.tsx







function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "font-poppins text-lg mb-2"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "text-sm"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "flex mr-5 rounded overflow-hidden"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "text-gray-700"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "flex flex-row items-center mb-3 md:mb-4"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "flex items-center mr-4"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var Name = dist_default().p(_templateObject());
var Contact = dist_default().p(_templateObject1());
var ImgContainer = dist_default().div(_templateObject2());
var Title = dist_default()(Contact)(_templateObject3());
var RowContainer = dist_default().div(_templateObject4());
var InfoIcon = dist_default().div(_templateObject5());
var ContactCard = function(param) {
    var firstName = param.firstName, lastName = param.lastName, email = param.email, phoneNumber = param.phoneNumber, title = param.title, photoUrl = param.photoUrl;
    var t = (0,esm/* useTranslation */.$G)('enum').t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowContainer, {
                children: [
                    photoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                            objectFit: "cover",
                            src: photoUrl,
                            sizes: [
                                70,
                                80
                            ],
                            unoptimized: true
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Name, {
                                children: [
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: t("RepresentativeTitle.".concat(title))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                            src: mail_green,
                            sizes: [
                                20,
                                30
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                        children: email
                    })
                ]
            }),
            phoneNumber ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                            src: phone_green,
                            sizes: [
                                20,
                                30
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                        children: phoneNumber
                    })
                ]
            }) : null
        ]
    }));
};


/***/ }),

/***/ 27138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ErrorContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-1 flex-col items-center justify-center"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "font-semibold text-center text-3xl mb-3"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject());
var Title = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().p(_templateObject1());
var ErrorContainer = function(param) {
    var title = param.title, message = param.message;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                children: title
            }),
            message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-gray-700",
                children: message
            })
        ]
    }));
};


/***/ }),

/***/ 32681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ IdTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  inline-block\n  px-2\n  py-[5px]\n  rounded\n  bg-gray-300\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-bold\n  text-xs\n  uppercase\n  text-gray-600\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var TagContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject());
var TagTitle = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().p(_templateObject1());
var IdTag = function(_param) /*#__PURE__*/ {
    var id = _param.id, props = _objectWithoutProperties(_param, [
        "id"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagContainer, _objectSpread({}, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TagTitle, {
            children: [
                "ID ",
                id
            ]
        })
    }));
};



/***/ }),

/***/ 53532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ OnboardingCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/next-router-query/dist/next-router-query.esm.js
var next_router_query_esm = __webpack_require__(15288);
// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
// EXTERNAL MODULE: ../core/src/components/Button.tsx
var Button = __webpack_require__(36573);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../core/src/components/Modal.tsx
var Modal = __webpack_require__(27581);
// EXTERNAL MODULE: ../core/src/components/Inputs/TextInput.tsx
var TextInput = __webpack_require__(10809);
// EXTERNAL MODULE: ../core/src/components/Inputs/PhoneInput.tsx + 1 modules
var PhoneInput = __webpack_require__(70331);
// EXTERNAL MODULE: ../core/src/components/Inputs/DatePicker.tsx + 1 modules
var DatePicker = __webpack_require__(65912);
// EXTERNAL MODULE: ../core/src/components/Forms/Form.tsx
var Form = __webpack_require__(48375);
// EXTERNAL MODULE: ../core/src/components/Inputs/Select.tsx
var Select = __webpack_require__(41673);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
// EXTERNAL MODULE: ../core/src/components/Inputs/CheckBox.tsx
var CheckBox = __webpack_require__(76008);
// EXTERNAL MODULE: ../core/src/utils/index.ts
var utils = __webpack_require__(75920);
;// CONCATENATED MODULE: ../core/src/components/OnboardingModal.tsx
















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "text-lg font-medium text-gray-800 -mt-4 mb-8"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  justify-between\n  border-top\n  border-gray-400\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "flex flex-col space-y-2 mb-8"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "flex flex-col md:flex-row space-x-0 space-y-2 md:space-y-0 md:space-x-6 lg:space-x-8"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var Title = dist_default().p(_templateObject());
var Footer = dist_default().div(_templateObject1());
var InputsContainer = dist_default().div(_templateObject2());
var Line = dist_default().div(_templateObject3());
var OnboardingModal = function(_param1) {
    var _open = _param1.open, open = _open === void 0 ? false : _open, onClose = _param1.onClose, intent = _param1.intent, auctionId = _param1.auctionId, cadastralPlotId = _param1.cadastralPlotId, user = _objectWithoutProperties(_param1, [
        "open",
        "onClose",
        "intent",
        "auctionId",
        "cadastralPlotId"
    ]);
    var firstName = user.firstName, lastName = user.lastName, dateOfBirth = user.dateOfBirth, address = user.address, phoneNumber = user.phoneNumber, countryCode = user.countryCode, company = user.company;
    var ref7 = company !== null && company !== void 0 ? company : {}, companyId = ref7.id, companyName = ref7.companyName, legalCode = ref7.legalCode, vatCode = ref7.vatCode, representativeFirstName = ref7.firstName, representativeLastName = ref7.lastName, streetAddress = ref7.streetAddress;
    var ref1 = (0,esm/* useTranslation */.$G)([
        'settings',
        'enum',
        'common'
    ]), t = ref1.t, i18n = ref1.i18n;
    var data1 = (0,generated/* useCountriesQuery */.VW)().data;
    var ref2 = _slicedToArray((0,generated/* useUpdatePersonDetailsMutation */.M3Z)(), 1), updatePersonDetailsMutation = ref2[0];
    var ref3 = _slicedToArray((0,generated/* useUpdateCompanyMutation */.lsD)(), 1), updateCompanyMutation = ref3[0];
    var ref4 = _slicedToArray((0,generated/* useCreateCompanyMutation */.f4G)(), 1), createCompanyMutation = ref4[0];
    var ref5 = _slicedToArray((0,generated/* useRequestAuctionPermissionMutation */.l5I)(), 1), requestAuctionPermissionMutation = ref5[0];
    var methods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            firstName: firstName,
            lastName: lastName,
            dateOfBirth: dateOfBirth,
            address: address,
            phoneNumber: phoneNumber,
            countryCode: countryCode || i18n.language.toUpperCase(),
            company: {
                firstName: representativeFirstName,
                lastName: representativeLastName,
                companyName: companyName,
                legalCode: legalCode,
                vatCode: vatCode,
                streetAddress: streetAddress
            }
        }
    });
    var options = (0,react.useMemo)(function() {
        return (data1 === null || data1 === void 0 ? void 0 : data1.countries.map(function(param) {
            var isoCode = param.isoCode;
            return {
                label: t("enum:CountryCode.".concat(isoCode)),
                value: isoCode
            };
        })) || [];
    }, [
        data1,
        t
    ]);
    var ref6 = (0,react.useState)(!!company), companyMode = ref6[0], setCompanyMode = ref6[1];
    var onSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(_param) {
            var companyInput, input, ref, mutation, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        companyInput = _param.company, input = _objectWithoutProperties(_param, [
                            "company"
                        ]);
                        ;
                        if (companyMode) {
                            mutation = companyId ? updateCompanyMutation : createCompanyMutation;
                            mutation({
                                variables: {
                                    input: _objectSpread({}, companyInput, {
                                        id: companyId
                                    })
                                }
                            });
                        }
                        _ctx.next = 5;
                        return updatePersonDetailsMutation({
                            variables: {
                                input: input
                            }
                        });
                    case 5:
                        data = _ctx.sent.data;
                        error = data === null || data === void 0 ? void 0 : (ref = data.updatePersonDetails) === null || ref === void 0 ? void 0 : ref.error;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", (0,utils/* setFormFieldsErrorTranslations */.U5)(setError, error, {
                            phoneNumber: 'UpdatePersonDetailsPhoneNumberError'
                        }));
                    case 9:
                        _ctx.next = 11;
                        return requestAuctionPermissionMutation({
                            variables: {
                                input: {
                                    intent: intent,
                                    auctionId: auctionId,
                                    cadastralPlotId: cadastralPlotId
                                }
                            }
                        });
                    case 11:
                        onClose();
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(_param) {
            return _ref.apply(this, arguments);
        };
    }();
    var register = methods.register, control = methods.control, setError = methods.setError;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        open: open,
        onClose: onClose,
        cardClassname: "md:w-[680px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: t('clientInformation')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, _objectSpread({}, methods, {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputsContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col md:flex-row space-y-4 md:space-x-8 md:space-y-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
                                        checked: !companyMode,
                                        onChange: function() {
                                            return setCompanyMode(false);
                                        },
                                        name: "physical",
                                        label: t('physical')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
                                        checked: companyMode,
                                        onChange: function() {
                                            return setCompanyMode(true);
                                        },
                                        name: "juridical",
                                        label: t('juridical')
                                    })
                                ]
                            }),
                            companyMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('representativeFirstName')
                                            }, register('company.firstName', {
                                                required: true
                                            }))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('representativeLastName')
                                            }, register('company.lastName', {
                                                required: true
                                            })))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('companyName')
                                            }, register('company.companyName', {
                                                required: true
                                            }))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('streetAddress')
                                            }, register('company.streetAddress', {
                                                required: true
                                            })))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('legalCode')
                                            }, register('company.legalCode', {
                                                required: true
                                            }))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('vatCode'),
                                                className: "flex-1"
                                            }, register('company.vatCode')))
                                        ]
                                    })
                                ]
                            }, "company") : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                        label: t('firstName')
                                    }, register('firstName', {
                                        required: true
                                    }))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                        label: t('lastName')
                                    }, register('lastName', {
                                        required: true
                                    })))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        control: control,
                                        name: "dateOfBirth",
                                        rules: {
                                            required: true
                                        },
                                        render: function(param) {
                                            var field = param.field;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(DatePicker/* DatePicker */.M, _objectSpread({
                                                label: t('dateOfBirth'),
                                                className: "flex-1"
                                            }, field));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        control: control,
                                        name: "phoneNumber",
                                        rules: {
                                            required: true
                                        },
                                        render: function(param) {
                                            var field = param.field;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(PhoneInput/* PhoneInput */.s, _objectSpread({
                                                label: t('common:phoneNumber')
                                            }, field));
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                        label: t('address')
                                    }, register('address', {
                                        required: true
                                    }))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        control: control,
                                        name: "countryCode",
                                        rules: {
                                            required: true
                                        },
                                        render: function(param1) {
                                            var field = param1.field;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select/* Select */.P, {
                                                label: t('countryCode'),
                                                options: options,
                                                onChange: function(option) {
                                                    return field.onChange(option === null || option === void 0 ? void 0 : option.value);
                                                },
                                                value: options.find(function(param) {
                                                    var value = param.value;
                                                    return value === field.value;
                                                }),
                                                isSearchable: true,
                                                menuPlacement: "auto"
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                type: "button",
                                value: "close-onboarding",
                                title: t('common:close'),
                                onClick: onClose,
                                secondary: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                type: "submit",
                                value: "submit-onboarding",
                                title: t('common:continue')
                            })
                        ]
                    })
                ]
            }))
        ]
    }));
};


;// CONCATENATED MODULE: ../assets/icons/signature.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSignature = function SvgSignature(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.917 37a7.962 7.962 0 0 0 4.77-1.54c1.425-1.028 2.643-2.448 3.656-4.262 1.013-1.813 1.793-3.928 2.338-6.344.545-2.415.818-5.012.818-7.788 0-2.352-.258-4.556-.776-6.61-.517-2.054-1.26-3.868-2.231-5.44-.97-1.573-2.136-2.802-3.496-3.688C20.636.443 19.106 0 17.406 0c-1.446 0-2.753.375-3.921 1.126-1.17.751-2.097 1.764-2.784 3.04C10.012 5.44 9.67 6.863 9.67 8.436c0 1.814.34 3.517 1.02 5.111a17.051 17.051 0 0 0 2.71 4.378 23.237 23.237 0 0 0 3.719 3.517c1.353 1.02 2.702 1.863 4.048 2.53.213.113.446.17.701.17.383 0 .695-.128.936-.383.24-.255.36-.546.36-.871a1.281 1.281 0 0 0-.744-1.169c-.835-.411-1.813-1.013-2.932-1.807-1.12-.793-2.21-1.757-3.273-2.89a15.373 15.373 0 0 1-2.635-3.857c-.694-1.438-1.041-3.014-1.041-4.729 0-1.048.216-1.994.648-2.837.432-.843 1.017-1.509 1.753-1.998a4.362 4.362 0 0 1 2.466-.733c1.671 0 3.124.641 4.356 1.923 1.233 1.283 2.186 3 2.859 5.154s1.01 4.527 1.01 7.12c0 2.337-.213 4.537-.639 6.598-.425 2.062-1.016 3.875-1.774 5.44-.758 1.566-1.647 2.796-2.667 3.688-1.02.893-2.118 1.339-3.294 1.339-.751 0-1.304-.23-1.658-.69-.354-.461-.531-1.06-.531-1.797 0-.892.269-1.923.807-3.092.539-1.169 1.304-2.355 2.296-3.56.991-1.204 2.174-2.32 3.549-3.347a18.416 18.416 0 0 1 4.58-2.486c1.678-.63 3.467-.946 5.366-.946.481 0 .722.198.722.595 0 .751-.124 1.413-.372 1.987-.248.574-.372 1.222-.372 1.945 0 .666.22 1.197.66 1.594.438.396.998.595 1.678.595.694 0 1.406-.191 2.136-.574.73-.383 1.442-.857 2.136-1.424a36.69 36.69 0 0 0 1.944-1.7 35.166 35.166 0 0 1 1.594-1.424c.46-.383.819-.574 1.074-.574.226 0 .379.174.457.52.077.348.152.777.222 1.287.072.51.21 1.02.415 1.53.206.51.542.938 1.01 1.285.467.348 1.133.521 1.997.521.354 0 .751-.053 1.19-.16.44-.105.83-.272 1.17-.499.226-.155.41-.347.552-.573a1.45 1.45 0 0 0 .213-.787 1.34 1.34 0 0 0-.32-.903c-.212-.248-.502-.372-.87-.372-.327 0-.614.078-.861.234a1.438 1.438 0 0 1-.776.234c-.34 0-.577-.188-.712-.564a6.311 6.311 0 0 1-.298-1.38 13.677 13.677 0 0 0-.297-1.648c-.135-.552-.368-1.013-.702-1.381-.332-.369-.839-.553-1.519-.553-.595 0-1.243.184-1.945.553-.701.368-1.402.825-2.104 1.37a40.228 40.228 0 0 0-1.987 1.648 50.919 50.919 0 0 1-1.615 1.38c-.453.37-.78.553-.977.553-.142 0-.213-.07-.213-.212 0-.227.113-.63.34-1.211.227-.581.34-1.212.34-1.892 0-.864-.336-1.558-1.01-2.083-.672-.524-1.569-.786-2.688-.786-2.224 0-4.332.372-6.322 1.116a21.482 21.482 0 0 0-5.451 2.975c-1.644 1.24-3.06 2.604-4.25 4.091-1.191 1.488-2.112 2.99-2.764 4.506-.651 1.516-.977 2.911-.977 4.186 0 1.389.39 2.533 1.169 3.432.779.9 1.99 1.35 3.634 1.35ZM1.53 31.028h47.924c.41 0 .768-.149 1.073-.446.304-.298.457-.659.457-1.084 0-.41-.153-.769-.457-1.073a1.468 1.468 0 0 0-1.073-.457H1.53c-.41 0-.768.152-1.073.457A1.47 1.47 0 0 0 0 29.498c0 .425.152.786.457 1.084.305.297.662.446 1.073.446Zm-.51-6.737c.241.241.524.361.85.361.326 0 .616-.12.872-.36l5.695-5.675c.241-.241.361-.528.361-.86 0-.334-.12-.62-.36-.862a1.234 1.234 0 0 0-.872-.36c-.326 0-.61.12-.85.36L1.02 22.57c-.255.24-.382.528-.382.86 0 .333.127.62.382.861Zm5.696 0c.24.241.524.361.85.361.326 0 .616-.12.871-.36.241-.242.361-.529.361-.862 0-.332-.12-.62-.36-.86l-5.696-5.675a1.234 1.234 0 0 0-.872-.36c-.326 0-.609.12-.85.36-.255.241-.382.528-.382.861 0 .333.127.62.382.86l5.696 5.675Z",
    fill: "#CCC"
  })));
};

/* harmony default export */ var signature = (SvgSignature);
;// CONCATENATED MODULE: ../assets/icons/participant-card.svg
var participant_card_path;

function participant_card_extends() { participant_card_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return participant_card_extends.apply(this, arguments); }



var SvgParticipantCard = function SvgParticipantCard(props) {
  return /*#__PURE__*/react.createElement("svg", participant_card_extends({
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), participant_card_path || (participant_card_path = /*#__PURE__*/react.createElement("path", {
    d: "M30.86 12.439h12.159c.354 0 .647-.117.88-.35a1.16 1.16 0 0 0 .35-.852c0-.335-.117-.62-.35-.853a1.194 1.194 0 0 0-.88-.35h-12.16c-.335 0-.624.117-.866.35a1.138 1.138 0 0 0-.363.853c0 .335.12.62.363.852.242.233.531.35.867.35Zm0 8.777h12.159c.354 0 .647-.117.88-.35a1.16 1.16 0 0 0 .35-.852c0-.335-.117-.62-.35-.853a1.194 1.194 0 0 0-.88-.349h-12.16c-.335 0-.624.116-.866.35a1.138 1.138 0 0 0-.363.852c0 .335.12.62.363.852.242.233.531.35.867.35Zm0 8.805h12.159c.354 0 .647-.117.88-.35a1.16 1.16 0 0 0 .35-.852c0-.335-.117-.624-.35-.866a1.17 1.17 0 0 0-.88-.364h-12.16c-.335 0-.624.121-.866.364a1.183 1.183 0 0 0-.363.866c0 .335.12.62.363.853.242.232.531.349.867.349Zm-23.09 0h17.443c.336 0 .582-.102.74-.308.16-.204.239-.465.239-.782 0-.522-.196-1.198-.587-2.027-.392-.829-.988-1.663-1.79-2.502-.8-.838-1.812-1.546-3.032-2.124-1.22-.578-2.651-.866-4.291-.866-1.659 0-3.098.288-4.319.866-1.22.578-2.227 1.286-3.019 2.125-.792.838-1.383 1.672-1.775 2.501-.39.83-.587 1.505-.587 2.027 0 .317.08.578.238.782.158.206.405.308.74.308Zm8.722-10.147c1.342 0 2.478-.503 3.41-1.51.932-1.006 1.398-2.254 1.398-3.745 0-1.416-.466-2.637-1.398-3.662-.932-1.025-2.068-1.537-3.41-1.537s-2.488.512-3.438 1.537c-.95 1.025-1.426 2.246-1.426 3.662 0 1.49.475 2.74 1.426 3.746.95 1.006 2.096 1.51 3.438 1.51ZM6.652 40H44.78c2.236 0 3.909-.554 5.017-1.663 1.11-1.109 1.664-2.754 1.664-4.934V6.625c0-2.18-.555-3.83-1.664-4.948C48.69.56 47.017 0 44.78 0H6.653c-2.2 0-3.858.554-4.976 1.663C.56 2.772 0 4.426 0 6.625v26.778c0 2.18.559 3.825 1.677 4.934C2.795 39.446 4.454 40 6.653 40Zm.057-3.13c-1.156 0-2.046-.308-2.67-.923-.624-.615-.936-1.519-.936-2.712V6.766c0-1.212.312-2.12.936-2.726.624-.606 1.514-.908 2.67-.908h38.015c1.155 0 2.05.302 2.683.908.634.606.95 1.514.95 2.726v26.47c0 1.193-.316 2.097-.95 2.712-.633.615-1.528.922-2.683.922H6.709Z",
    fill: "#CCC"
  })));
};

/* harmony default export */ var participant_card = (SvgParticipantCard);
;// CONCATENATED MODULE: ../assets/icons/clock-wait.svg
var clock_wait_path;

function clock_wait_extends() { clock_wait_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clock_wait_extends.apply(this, arguments); }



var SvgClockWait = function SvgClockWait(props) {
  return /*#__PURE__*/react.createElement("svg", clock_wait_extends({
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), clock_wait_path || (clock_wait_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.961 17.922c.6 0 1.185-.057 1.755-.172a8.545 8.545 0 0 0 1.643-.505 5.974 5.974 0 0 1-.91-1.444 7.152 7.152 0 0 1-2.488.433 7.133 7.133 0 0 1-2.826-.56 7.212 7.212 0 0 1-2.31-1.56 7.305 7.305 0 0 1-1.554-2.321 7.172 7.172 0 0 1-.56-2.832A7.235 7.235 0 0 1 6.123 2.25a7.132 7.132 0 0 1 2.826-.561 7.179 7.179 0 0 1 4.747 1.754 7.41 7.41 0 0 1 1.594 1.944c.421.74.7 1.543.832 2.41.252-.038.54-.049.866-.034.326.015.615.048.867.1a8.735 8.735 0 0 0-.983-3.07 9.21 9.21 0 0 0-1.977-2.505A9.107 9.107 0 0 0 12.17.605 8.631 8.631 0 0 0 8.95 0a8.623 8.623 0 0 0-3.453.7 9 9 0 0 0-2.854 1.943A9.305 9.305 0 0 0 .705 5.508 8.565 8.565 0 0 0 0 8.96c0 1.222.235 2.373.705 3.454a9.258 9.258 0 0 0 1.943 2.865 9.066 9.066 0 0 0 2.86 1.943c1.08.466 2.232.7 3.453.7ZM4.52 9.95H8.95a.674.674 0 0 0 .689-.677V3.553a.665.665 0 0 0-.2-.488.665.665 0 0 0-.489-.2.674.674 0 0 0-.677.688v5.03H4.519a.674.674 0 0 0-.677.688c0 .194.065.355.194.484.13.13.291.194.483.194ZM16.745 18c.807 0 1.551-.204 2.232-.61a4.721 4.721 0 0 0 1.638-1.628c.41-.677.616-1.423.616-2.237 0-.822-.203-1.571-.61-2.249a4.642 4.642 0 0 0-1.627-1.62 4.311 4.311 0 0 0-2.249-.606c-.814 0-1.56.202-2.237.605a4.642 4.642 0 0 0-1.627 1.621 4.282 4.282 0 0 0-.61 2.249c0 .822.203 1.571.61 2.249.407.677.95 1.217 1.627 1.62a4.29 4.29 0 0 0 2.237.606Zm-.533-1.81a.683.683 0 0 1-.466-.189l-1.688-1.854a.352.352 0 0 1-.083-.167.834.834 0 0 1-.028-.2.58.58 0 0 1 .172-.427.567.567 0 0 1 .417-.172.564.564 0 0 1 .444.2l1.21 1.299 2.276-3.176a.592.592 0 0 1 .5-.255c.155 0 .293.055.41.166a.54.54 0 0 1 .179.411.616.616 0 0 1-.122.355L16.7 15.98c-.104.14-.267.211-.489.211Z",
    fill: "#000"
  })));
};

/* harmony default export */ var clock_wait = (SvgClockWait);
;// CONCATENATED MODULE: ../core/src/components/OnboardingCard.tsx












function OnboardingCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OnboardingCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OnboardingCard_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function OnboardingCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function OnboardingCard_templateObject() {
    var data = OnboardingCard_taggedTemplateLiteral([
        "flex"
    ]);
    OnboardingCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OnboardingCard_templateObject1() {
    var data = OnboardingCard_taggedTemplateLiteral([
        "flex-col"
    ]);
    OnboardingCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OnboardingCard_templateObject2() {
    var data = OnboardingCard_taggedTemplateLiteral([
        "\n  flex\n  flex-col\n  rounded-lg\n  bg-white\n  p-6\n  border\n  border-gray-400\n"
    ]);
    OnboardingCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OnboardingCard_templateObject3() {
    var data = OnboardingCard_taggedTemplateLiteral([
        "\n  text-lg\n  font-semibold\n"
    ]);
    OnboardingCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = OnboardingCard_taggedTemplateLiteral([
        "text-gray-800"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = OnboardingCard_taggedTemplateLiteral([
        "font-medium"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = OnboardingCard_taggedTemplateLiteral([
        "\n  w-[160px]\n  md:w-[230px]\n  h-2\n  rounded-sm\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var OnboardingCard_Line = dist_default().div(OnboardingCard_templateObject());
var Column = dist_default()(OnboardingCard_Line)(OnboardingCard_templateObject1());
var Container = dist_default().div(OnboardingCard_templateObject2());
var OnboardingCard_Title = dist_default().p(OnboardingCard_templateObject3());
var Text = dist_default().p(_templateObject4());
var Subtitle = dist_default().p(_templateObject5());
var Step = dist_default().div(_templateObject6(), function(param) {
    var $active = param.$active;
    return $active ? 'bg-green-500' : 'bg-gray-400';
});
var OnboardingCard = /*#__PURE__*/ (0,react.memo)(function(param) {
    var mode = param.mode;
    var t = (0,esm/* useTranslation */.$G)('onboarding').t;
    var query = (0,next_router_query_esm/* useRouterQuery */.o)();
    var data = (0,generated/* useSettingsQuery */.nqz)().data;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var closeModal = (0,react.useCallback)(function() {
        return setModalOpen(false);
    }, [
        setModalOpen
    ]);
    var openModal = (0,react.useCallback)(function() {
        return setModalOpen(true);
    }, [
        setModalOpen
    ]);
    var currentUser = data === null || data === void 0 ? void 0 : data.currentUser;
    var owner = mode === 'owner';
    var agreementSent = owner ? currentUser === null || currentUser === void 0 ? void 0 : currentUser.auctionAgreementSent : currentUser === null || currentUser === void 0 ? void 0 : currentUser.biddingAgreementSent;
    var id = query.id;
    return currentUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingCard_Title, {
                children: owner ? t('auctionOwnerForm') : t('auctionBidderForm')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                className: "mb-3",
                children: owner ? t('completeOwnerSteps') : t('completeBidderSteps')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnboardingCard_Line, {
                className: "space-x-2 mb-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                        $active: !!agreementSent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnboardingCard_Line, {
                className: "items-center mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                        src: agreementSent ? signature : participant_card,
                        width: 52,
                        height: 40,
                        className: "mr-3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                children: agreementSent ? owner ? t('ownerContract') : t('bidderContract') : t('participantData')
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                children: agreementSent ? owner ? t('ownerContractSubtitle') : t('bidderContractSubtitle') : t('contactInfoRequired')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingCard_Line, {
                className: "items-center",
                children: agreementSent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                            src: clock_wait,
                            width: 22,
                            height: 18,
                            className: "mr-2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                            children: t('contractBeingPrepared')
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    value: "open-onboarding-modal",
                    title: t('enterData'),
                    onClick: openModal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingModal, OnboardingCard_objectSpread({}, currentUser, {
                open: modalOpen,
                onClose: closeModal,
                intent: owner ? generated/* AuctionPermissionIntent.Start */.UPS.Start : generated/* AuctionPermissionIntent.Bid */.UPS.Bid,
                auctionId: owner ? undefined : id,
                cadastralPlotId: owner ? id : undefined
            }))
        ]
    }) : null;
});


/***/ }),

/***/ 17094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ResponsiveImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75920);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32345);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ResponsiveImage = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .clientOnlyComponent */ .V4)(function(_param) {
    var sizes = _param.sizes, widths = _param.widths, heights = _param.heights, props = _objectWithoutProperties(_param, [
        "sizes",
        "widths",
        "heights"
    ]);
    var mobile = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useDeviceMediaQuery */ .mL)().mobile;
    var ref = _slicedToArray(widths !== null && widths !== void 0 ? widths : sizes, 2), mobileWidth = ref[0], desktopWidth = ref[1];
    var ref1 = _slicedToArray(heights !== null && heights !== void 0 ? heights : sizes, 2), mobileHeight = ref1[0], desktopHeight = ref1[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({}, props, {
        width: mobile ? mobileWidth : desktopWidth,
        height: mobile ? mobileHeight : desktopHeight
    })));
});



/***/ }),

/***/ 60761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63964);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-self: center;\n  width: 44px;\n  height: 44px;\n  border: 4px ",
        " solid;\n  border-top: 4px ",
        " solid;\n  border-radius: 50%;\n  -webkit-animation: spCircRot 0.6s infinite linear;\n  animation: spCircRot 0.6s infinite linear;\n\n  @-webkit-keyframes spCircRot {\n    from {\n      -webkit-transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(359deg);\n    }\n  }\n  @keyframes spCircRot {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(359deg);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Spinner = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a15f7bb9-0"
})(_templateObject(), (_config__WEBPACK_IMPORTED_MODULE_1___default().colors.gray[400]), (_config__WEBPACK_IMPORTED_MODULE_1___default().colors.secondary[500]));


/***/ })

}]);